// extracted by mini-css-extract-plugin
export default {"ellipsis":"TableBody_ellipsis__JYaQq","buttons":"TableBody_buttons__F8gqH"};